
import { BaseApi } from '@/api/BaseApi'
import Config from '@/const/Config'
import {
  DakokuReq, GetKinmuListRes, GetDakokuReq, DakokuData, KyuukeiReq, GetKinmuListReq,
  GetKintaiSummaryRes, GetKintaiSummaryReq, DakokuSyouninRes, DakokuSyouninReq, HonninNotesReq,
  CloseKintaiSummaryReq, CloseCancelKintaiSummaryReq, KinmuListInfo, HakenModifyDatas, boolRes, GetKinmuListBySummaryIdReq, GetHakenKinmuListRes, KintaiSummaryData, RecalcDakokByDakokuInfouReq,
} from '@/types/Dakoku'
import {  SoumuSyuuseiReq } from '@/types/SoumuSyuusei'

export class DakokuApi extends BaseApi {

  /**
   * API実行当日の打刻情報を取得します
   * @returns
   */
  public async getDakokuData(req: GetDakokuReq): Promise<DakokuData> {
    try {
      const res = await this.post<DakokuData>(Config.API_URL + '/dakoku/get', req)
      return res.data
    } catch (e: unknown) {
      throw e
    }
  }

  /**
   * 出勤打刻を実行し、実行結果を返します
   * @returns
   */
  public async syukkin(req: DakokuReq): Promise<boolean> {
    try {
      const res = await this.post<boolean>(Config.API_URL + '/dakoku/syukkin', req)
      return res.data
    } catch (e: unknown) {
      throw e
    }
  }

  /**
   * 出勤打刻を実行し、実行結果を返します
   * @returns
   */
  public async gaisyutsu(req: DakokuReq): Promise<boolean> {
    try {
      const res = await this.post<boolean>(Config.API_URL + '/dakoku/gaisyutsu', req)
      return res.data
    } catch (e: unknown) {
      throw e
    }
  }

  /**
   * 出勤打刻を実行し、実行結果を返します
   * @returns
   */
  public async modori(req: DakokuReq): Promise<boolean> {
    try {
      const res = await this.post<boolean>(Config.API_URL + '/dakoku/modori', req)
      return res.data
    } catch (e: unknown) {
      throw e
    }
  }

  /**
   * 出勤打刻を実行し、実行結果を返します
   * @returns
   */
  public async taikin(req: DakokuReq): Promise<boolean> {
    try {
      const res = await this.post<boolean>(Config.API_URL + '/dakoku/taikin', req)
      return res.data
    } catch (e: unknown) {
      throw e
    }
  }

  /**
   * 休憩時間登録を実行し、実行結果を返します
   * @returns
   */
  public async kyuukei(req: KyuukeiReq): Promise<boolean> {
    try {
      const res = await this.post<boolean>(Config.API_URL + '/dakoku/kyuukei', req);
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }

  /**
   * 休憩時間登録を実行し、実行結果を返します
   * @returns
   */
  public async honninNotes(req: HonninNotesReq): Promise<boolRes> {
    try {
      const res = await this.post<boolRes>(Config.API_URL + '/dakoku/honnin_notes', req);
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }

  /**
   * 指定部課・期間の打刻一覧を取得します
   * @returns
   */
  public async getKinmuList(req: GetKinmuListReq): Promise<GetKinmuListRes> {
    try {
      const res = await this.post<GetKinmuListRes>(Config.API_URL + '/dakoku/list', req)
      return res.data
    } catch (e: unknown) {
      throw e
    }
  }


  /**
   * 指定部課・期間の打刻サマリーを取得します
   * @returns
   */
  public async getKintaiSummary(req: GetKintaiSummaryReq): Promise<GetKintaiSummaryRes> {
    try {
      const res = await this.post<GetKintaiSummaryRes>(Config.API_URL + '/dakoku/summary', req)
      return res.data
    } catch (e: unknown) {
      throw e
    }
  }

  /**
   * 指定部課・期間の打刻サマリーを取得します
   * @returns
   */
  public async getKintaiSummaryBySummaryId(summaryId: number): Promise<GetKintaiSummaryRes> {
    try {
      const res = await this.post<GetKintaiSummaryRes>(Config.API_URL + '/dakoku/summary/by_summary_id', {summaryId})
      return res.data
    } catch (e: unknown) {
      throw e
    }
  }

  /**
   * 指定部課・期間の打刻サマリーを取得します
   * @returns
   */
  public async dakokuSyounin(req: DakokuSyouninReq): Promise<DakokuSyouninRes> {
    try {
      const res = await this.post<DakokuSyouninRes>(Config.API_URL + '/dakoku/syounin', req)
      return res.data
    } catch (e: unknown) {
      throw e
    }
  }

  /**
   * 打刻承認を一括登録します
   * @param params
   * @returns
   */
  public async ikkatsuSyounin(params: number[]): Promise<boolean> {
    try {
      const res = await this.post<boolean>(Config.API_URL + `/dakoku/ikkatsu_syounin`, { 'dakokuList': params });
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 指定部課・期間の打刻サマリーを取得します
   * @returns
   */
  public async closeKintaiSummary(req: CloseKintaiSummaryReq): Promise<boolean> {
    try {
      const res = await this.post<boolean>(Config.API_URL + '/dakoku/summary/close', req)
      return res.data
    } catch (e: unknown) {
      throw e
    }
  }

  /**
   * 指定部課・期間の打刻サマリーを取得します
   * @returns
   */
  public async closeCancelKintaiSummary(req: CloseCancelKintaiSummaryReq): Promise<boolean> {
    try {
      const res = await this.post<boolean>(Config.API_URL + '/dakoku/summary/cancel', req)
      return res.data
    } catch (e: unknown) {
      throw e
    }
  }

  /**
   * サマリーの更新を登録します。
   * @param req
   * @returns 登録したデータ
   */
  public async modifyKintaiSummary(req: KintaiSummaryData): Promise<boolean> {
    try {
      const res = await this.post<boolean>(Config.API_URL + '/dakoku/summary/modify', {summaryEditData: req})
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }

  public async getKinmuListInfoByDakokuId(dakokuId: number) {
    try {
      const res = await this.post<KinmuListInfo | null>(Config.API_URL + '/dakoku/kinmu_list_info_by_dakoku_id', { dakokuId })
      if (res.data) {
        // KinmuListInfoはクラスなので受け取った値をもとにインスタンスを生成する（そうしないとメソッドなどが増えた場合に使用できないため）
        return Object.assign(new KinmuListInfo(), res.data);
      } else {
        return null
      }
    } catch (e: unknown) {
      throw e
    }
  }

  public async setHakenModifies(params: HakenModifyDatas) {
    try {
      return await this.post(Config.API_URL + `/dakoku/haken_modifies`, params);
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 指定部課・期間の打刻一覧を取得します
   * @returns
   */
  public async getHakenKinmuList(req: GetKinmuListReq): Promise<GetHakenKinmuListRes> {
    try {
      const res = await this.post<GetHakenKinmuListRes>(Config.API_URL + '/dakoku/list/haken/by_period', req)
      return res.data
    } catch (e: unknown) {
      throw e
    }
  }

  public async getHakenKinmuListBySummaryId(req: GetKinmuListBySummaryIdReq): Promise<GetHakenKinmuListRes>{
    try {
      const res = await this.post<GetHakenKinmuListRes>(Config.API_URL + '/dakoku/list/haken/by_summary_id', req)
      return res.data
    } catch (e: unknown) {
      throw e
    }
  }

  /**
   * 総務修正を登録します。
   * @param req
   * @returns 登録したデータ
   */
  public async updateSoumuSyuusei(req: SoumuSyuuseiReq): Promise<boolean> {
    try {
      const res = await this.post<boolean>(Config.API_URL + `/dakoku/soumu_syuusei`, req);
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }

  /**
   * 打刻の再計算を行います
   */
  public async recalcDakokuByDakokuInfos(req: RecalcDakokByDakokuInfouReq): Promise<boolean> {
    try {
      const res = await this.post<boolean>(Config.API_URL + `/dakoku/recalc_by_infos`, req);
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }
}
